import { Fragment } from 'react';

import { Listbox, Transition } from '@headlessui/react';
import { IconType } from 'react-icons';
import { BiCheck } from 'react-icons/bi';
import { HiFilter } from 'react-icons/hi';
import { IoMdArrowDropdown } from 'react-icons/io';

import { SelectOption } from './Select';
import Text from './Text';

// type Option = {
//   label: string;
//   value: string;
// };

interface Props {
  onChange: any;
  displayLabel: string;
  options?: SelectOption[] | any;
  values: string[] | any;
  icon?: IconType;
}

const MultiSelectCheckbox: React.FC<Props> = ({
  options,
  onChange,
  displayLabel,
  icon: Icon,
  values,
}) => {
  const hasOption = values ? values!.length > 0 : false;
  return (
    <Listbox value={values} onChange={(_v) => {}} multiple>
      <div className="relative w-full">
        <Listbox.Button
          className={`${
            hasOption ? 'bg-slate-100' : ''
          }  pt-3 w-full flex justify-between gap-2 px-4 pointer-events-auto items-center rounded-lg border-[1px] border-gray-300 py-4 text-left focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm`}
        >
          {/* Label */}
          <div className="flex">
            {/* Icon spot */}
            <span
              className={`flex mr-2 ${
                hasOption ? ' text-gray-600' : 'text-gray-600/70'
              }`}
            >
              {Icon ? <Icon size={15} /> : <HiFilter size={20} />}
            </span>
            <div className="flex flex-row">
              <span
                className={`transition-all text-xs md:text-sm ${
                  hasOption
                    ? 'transfrom -translate-y-1 text-gray-700'
                    : 'mt-0.5 text-gray-600'
                }`}
              >
                <Text as="p" text={displayLabel}></Text>
              </span>

              <span className="absolute !w-12 truncate top-6 z-50">
                {values && values.length > 0 && (
                  <Text
                    as="p"
                    text={
                      values.length > 2 && values[1].length > 3
                        ? values.slice(0, 2).join(', ')
                        : values.length === 1
                        ? values[0]
                        : `${values[0]}, ${values[1].slice(0, 6)}...`
                    }
                    className="inline text-primary font-semibold text-[12px] truncate"
                  />
                )}
              </span>
            </div>
          </div>

          {hasOption ? (
            <IoMdArrowDropdown
              size={16}
              className="justify-end items-end text-primary "
            />
          ) : (
            <IoMdArrowDropdown
              size={16}
              className="justify-end items-end text-gray-700 "
            />
          )}
        </Listbox.Button>

        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-[9999] mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {options.map((option: any) => (
              <>
                <Listbox.Option
                  key={option.value}
                  className={({ active }) =>
                    `relative z-[9999] cursor-pointer select-none py-2 pl-10 pr-4 ${
                      active ? 'bg-gray-100 text-primary' : 'text-gray-600'
                    }`
                  }
                  value={option.label}
                  onClick={() => onChange(option.label)}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? 'font-medium' : 'font-normal'
                        }`}
                      >
                        {option.label}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-primary">
                          <BiCheck className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              </>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

export default MultiSelectCheckbox;
